import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
// import logo from "../assets/img/logo1.png";
import navIcon1 from "../assets/img/nav-icon1.svg";
import github from '../assets/img/github.svg';
import email from '../assets/img/envelope.svg';
import telephone from "../assets/img/telephone-fill.svg"
export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <MailchimpForm />
          <Col size={12} sm={6}>
            {/* <img src={logo} alt="Logo" /> */}
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
            <a href="https://www.linkedin.com/in/akshay-kumar-gaurav-6137a0236/" id="contact-linkedin" target="_blank "><img src={navIcon1} alt="Icon" /></a>
                <a href="https://github.com/AkshayKumarGaurav"  id="contact-github" target="_blank "><img src={github} alt="Icon" /></a>
                <a href="mailto:akshaykumargaurav@gmail.com" id="contact-email" target="_blank "><img src={email} alt="Icon" /></a>
              <a href="tel:+917070234553" target="_blank"  id="contact-phone"><img src={telephone} alt="Icon" /></a>
            </div>
            <p>Copyright © 2023  Akshay Kumar Gaurav</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}